import React from "react"
import { Link } from "react-router-dom";
import { Button } from "antd"
import { PlusOutlined } from "@ant-design/icons"
/* custom component */
import Header from "../../../../component/Header/Header"
import { PageContainer } from "../../../../component/Xcomponent"
import ContentRepoList from "../../../../component/ContentRepo/ContentRepoList/ContentRepoList";

const ContentRepoPregnancyList = props => {

    return (
        <>
            <Header
                title="Content Repo Pregnancy List"
                rightChildren={<Link to="/content-repo-pregnancy/add" ><Button type="primary" ><PlusOutlined />New</Button></Link>}
            />
            <PageContainer>
                <ContentRepoList refreshPageUrl={`content-repo-pregnancy/list`} pageUrl={`content-repo-pregnancy`} pageType="Pregnancy" />
            </PageContainer>
        </>
    )
}

export default ContentRepoPregnancyList